import { useTranslation } from "react-i18next";
import ChartNoData from "components/charting/ChartNoData";

interface AthleteProfilingChartNoDataProps {}

function AthleteProfilingChartNoData(props: AthleteProfilingChartNoDataProps) {
  const { t } = useTranslation();

  return (
    <ChartNoData
      title={t("charting.profiling_select_data_title")}
      description={t("charting.profiling_select_data_description")}
    />
  );
}

export default AthleteProfilingChartNoData;
